<template>
  <b-row>
    <b-col
      cols="12"
    >
      <b-table
        ref="customTable"
        small
        hover
        bordered
        responsive
        show-empty
        :items="provider"
        :busy="customTable.busy"
        :filter="customTable.filter"
        :fields="customTable.fields"
        :stacked="customTable.stacked"
        :sort-by.sync="customTable.sortBy"
        :sort-desc.sync="customTable.sortDesc"
        :sort-direction="customTable.sortDirection"
        :filter-included-fields="customTable.filterOn"
        :current-page="customTable.currentPage"
        :per-page="customTable.perPage"
      >
        <template #cell(index)="{ index }">
          {{ tableRowNumber({ currentPage: customTable.currentPage, perPage: customTable.perPage }, index) }}
        </template>

        <template #cell()="{ value }">
          <div
            class="text-md-nowrap"
            v-text="value"
          />
        </template>

        <template #table-busy>
          <div class="text-center py-5">
            <b-icon
              icon="stopwatch"
              font-scale="5"
              animation="cylon"
            />
            <p class="h3 py-2">
              <strong>Loading . . .</strong>
            </p>
          </div>
        </template>

        <template
          v-for="(_slotCallback, slotName) in $scopedSlots"
          #[slotName]="slotProperties"
        >
          <slot
            :name="slotName"
            v-bind="slotProperties"
          />
        </template>

      </b-table>
    </b-col>

    <b-col
      cols="12"
      md="6"
      class="mt-1 mb-md-0 mb-2"
    >
      <b-select
        v-model="customTable.perPage"
        :options="customTable.pageOptions"
        :disabled="customTable.busy"
        class="w-100 w-md-25"
        size="sm"
      />
    </b-col>

    <b-col
      cols="12"
      md="6"
      class="d-flex justify-content-center justify-content-md-end mt-1"
    >
      <b-pagination
        v-model="customTable.currentPage"
        :total-rows="totalRows"
        :per-page="customTable.perPage"
        :disabled="customTable.busy"
        class="mb-0"
        aria-controls="table"
        prev-text="Prev"
        next-text="Next"
        first-number
        last-number
        pills
      />
    </b-col>
  </b-row>
</template>
<script>
import QUERY from 'lodash'
import MISC from '@/mixins/misc'

export default {
  name: 'CustomTable',
  mixins: [
    MISC
  ],

  props: {
    provider: {
      type: [Function, Array],
      default: () => [],
      required: true
    },
    fields: {
      type: [Object, Array],
      default: () => ({}),
      required: true
    },
    filter: {
      type: [Object, Array],
      default: () => ({
        search: null
      }),
      required: true
    },
    filterOn: {
      type: Array,
      default: () => []
    },
    sortBy: {
      type: String,
      default: () => 'id',
      required: true
    },
    sortDesc: {
      type: Boolean,
      default: () => false,
      required: true
    },
    sortDirection: {
      type: String,
      default: () => 'asc',
      required: true
    },
    totalRows: {
      type: Number,
      default: () => 0,
      required: true
    },
    pageOptions: {
      type: Array,
      default: () => [10, 25, 50, 100]
    },
    perPage: {
      type: Number,
      default: () => 10,
      required: true
    },
    currentPage: {
      type: Number,
      default: () => 1,
      required: true
    },
    stacked: {
      type: Boolean,
      default: () => false
    },
    busy: {
      type: Boolean,
      default: () => true,
      required: true
    }
  },

  data () {
    return {
      customTable: {
        fields: this.fields,
        filter: this.filter,
        filterOn: this.filterOn,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        sortDirection: this.sortDirection,
        totalRows: this.totalRows,
        pageOptions: this.pageOptions,
        perPage: this.perPage,
        currentPage: this.currentPage,
        stacked: this.stacked,
        busy: this.busy
      }
    }
  },

  methods: {

    items () {
      if (this.$refs.customTable) {
        return this.$refs.customTable.localItems
      }

      return []
    },

    updateRow (payload = {}, whereClause = {}) {
      if (this.$refs.customTable) {
        const payloadID = { id: payload.id }
        const hasWhereClause = Object.keys(whereClause).length > 0
        const finalWhereClause = hasWhereClause ? Object.assign(whereClause, payloadID) : payloadID

        const tableRow = QUERY.find(this.$refs.customTable.localItems, finalWhereClause)

        if (tableRow) {
          Object.assign(tableRow, payload)
        }

        return tableRow
      }

      return null
    },

    refetch () {
      if (this.$refs.customTable) {
        this.$refs.customTable.refresh()
      }
    }
  }
}
</script>
